// Import centralized API configuration
import {
  BASE_API,
  API_VERSION,
  API_BASE_URL,
  PROXY_BASE_API,
  PROXY_API_VERSION,
  PROXY_API_BASE_URL
} from '../../../shared/config/apiConfig';

// User endpoints
export const USER_ENDPOINTS = {
  byEmail: (email) => `${API_BASE_URL}/users/email/${email}`,
  byOrganization: (tenantId) => `${API_BASE_URL}/users/organization/${tenantId}`,
  organizationMembers: (tenantId) => `${API_BASE_URL}/users/organizations/${tenantId}/members`,
  updateMemberRole: (tenantId, userId, roleId) => `${API_BASE_URL}/users/organizations/${tenantId}/members/${userId}/role/${roleId}`,
  updateMemberDetails: (tenantId, userId) => `${API_BASE_URL}/users/organizations/${tenantId}/members/${userId}`,
  removeMember: (tenantId, userId) => `${API_BASE_URL}/users/organizations/${tenantId}/members/${userId}`,
  batchUpdate: (tenantId) => `${API_BASE_URL}/users/organizations/${tenantId}/members/batch-update`
};

//{{base_url}}{{api_path}}/{{organization_id}}/{{member_id}}/role/{{role_id}}
//update member role
 

// Role endpoints
export const ROLE_ENDPOINTS = {
  all: (tenantId) => `${API_BASE_URL}/roles/all/${tenantId}`,
  active: (tenantId) => `${API_BASE_URL}/roles/active/${tenantId}`,
  create: `${API_BASE_URL}/roles/structured`,
  withPermissions: (tenantId, roleId) => `${API_BASE_URL}/roles/structured/${tenantId}/${roleId}`,
  createDefault: (tenantId) => `${API_BASE_URL}/roles/default/${tenantId}`,
  update: (tenantId, roleId) => `${API_BASE_URL}/roles/${tenantId}/${roleId}`,
  delete: (tenantId, roleId) => `${API_BASE_URL}/roles/${tenantId}/${roleId}`
};

// Division endpoints
export const DIVISION_ENDPOINTS = {
  byOrganization: (tenantId) => `${API_BASE_URL}/divisions/organizations/${tenantId}`,
  create: `${API_BASE_URL}/divisions`,
  update: (divId) => `${API_BASE_URL}/divisions/${divId}`,
  delete: (divId) => `${API_BASE_URL}/divisions/${divId}`,
  restore: (divId) => `${API_BASE_URL}/divisions/${divId}/restore`,
  members: (divId) => `${API_BASE_URL}/divisions/${divId}/members`,
  details: (divId) => `${API_BASE_URL}/divisions/${divId}/details`,
  forUser: (userId) => `${API_BASE_URL}/divisions/${userId}`,
  switchDivision: (divId) => `${API_BASE_URL}/divisions/${divId}/switch`
};

// Group/Team endpoints
export const GROUP_ENDPOINTS = {
  byOrganization: (tenantId) => `${API_BASE_URL}/groups/organizations/${tenantId}`,
  byDivision: (divId) => `${API_BASE_URL}/groups/divisions/${divId}`,
  standalone: (tenantId) => `${API_BASE_URL}/groups/standalone/${tenantId}`,
  create: `${API_BASE_URL}/groups`,
  createChild: `${API_BASE_URL}/groups/child`,
  update: (groupId) => `${API_BASE_URL}/groups/${groupId}`,
  delete: (groupId) => `${API_BASE_URL}/groups/${groupId}`,
  children: (parentGroupId) => `${API_BASE_URL}/groups/${parentGroupId}/children`,
  members: (groupId) => `${API_BASE_URL}/users/groups/${groupId}/users`
};

// Organization endpoints
export const ORGANIZATION_ENDPOINTS = {
  updateTheme: (tenantId) => `${API_BASE_URL}/organisations/${tenantId}`,
  getTheme: (tenantId) => `${API_BASE_URL}/organisations/${tenantId}`,
  getDetails: (tenantId) => `${API_BASE_URL}/organisations/${tenantId}`,
  update: (tenantId) => `${API_BASE_URL}/organisations/${tenantId}`
};

// Invitation endpoints
export const INVITATION_ENDPOINTS = {
  create: `${API_BASE_URL}/invitations`,
  byEmail: (email) => `${API_BASE_URL}/invitations/email/${email}`,
  list: `${API_BASE_URL}/invitations`,
  accept: (token) => `${API_BASE_URL}/invitations/accept/${token}`,
  delete:(invitationId) => `${API_BASE_URL}/invitations/${invitationId}`,
};

// Notifications endpoints
export const NOTIFICATION_ENDPOINTS = {
  create: (userId) =>  `${API_BASE_URL}/notification/users/${userId}/notifications`,
  getAll: (userId) =>  `${API_BASE_URL}/notification/users/${userId}/notifications`,
  getAllUnread: (userId) =>  `${API_BASE_URL}/notification/users/${userId}/notifications?unreadOnly=true`,
  markAsRead: (userId, notificationId) =>  `${API_BASE_URL}/notification/users/${userId}/notifications/${notificationId}/read`, //put
  markAllAsRead: (userId) => `${API_BASE_URL}/notification/users/${userId}/notifications/read-all`,
  delete: (userId, notificationId) =>  `${API_BASE_URL}/notification/users/${userId}/notifications/${notificationId}`,
};